import axios from "axios";
import { API_BASE } from "./_ApiBase";
import { APP_STORAGE } from "../../_Config/AppConfig.Storage";
import { API_LOAD_ENDPOINTS } from "../../../Web/Views/_ApiLoad.Endpoints";
import { AUTH_CONSTANTS } from "../../../Web/Views/Public/_Auth/_MODULES/_API";
import { STORAGE_SESSION_HELPER } from "../../HELPERS/storageSession.helper";


export const API_BASE_URL = API_BASE.API_URL;
export const API_STATIC_URL = API_BASE.STATIC_URL;
export const API_SOCKET_DOMAIN = API_BASE.SOCKET_URL;


// 🔥 KEY vía constante → URL vía registro de endpoints (sin strings crudos)
const REFRESH_TOKEN_URL = API_LOAD_ENDPOINTS[AUTH_CONSTANTS.REFRESH_TOKEN];


// Agregamos withCredentials de manera global para que las cookies. (como 'refreshToken') viajen automáticamente en cada petición hacia el backend.
const AXIOS_API_CREATE = axios.create({ baseURL: API_BASE_URL, withCredentials: true });


// ------------------------------------------ 🔥 REQUEST INTERCEPTOR 
AXIOS_API_CREATE.interceptors.request.use((config) => {
    const token = STORAGE_SESSION_HELPER.GET_STORAGE(APP_STORAGE.TOKEN_USER_AUTH);
    const isRefreshRequest = config?.url?.includes(REFRESH_TOKEN_URL);

    if (token && !isRefreshRequest) {
        if (config.headers && typeof config.headers.set === 'function') {
            config.headers.set('Authorization', `Bearer ${token}`);
        } else {
            config.headers = config.headers || {};
            config.headers['Authorization'] = `Bearer ${token}`;
        }
    }
    return config;
}, (error) => Promise.reject(error));


// ------------------------------------------ 🔥 RESPONSE INTERCEPTOR
let isRefreshing = false;
let failedQueue = [];


const processQueue = (error, token = null) => {
    failedQueue.forEach(prom => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });
    failedQueue = [];
};


AXIOS_API_CREATE.interceptors.response.use((response) => response, async (error) => {
    if (!error) return Promise.reject(new Error("Unknown Error"));

    const OPT_REQUEST = error.config;
    if (!OPT_REQUEST) return Promise.reject(error);

    const STATUS = error.response?.status;
    const ERROR_CODE = error.response?.data?.data?.code || error.response?.data?.code;

    if (STATUS === 401 && ERROR_CODE === "TOKEN_EXPIRED" && !OPT_REQUEST._retry) {

        if (isRefreshing) {
            return new Promise((resolve, reject) => {
                failedQueue.push({ resolve, reject });
            }).then(token => {
                OPT_REQUEST.headers = { ...(OPT_REQUEST.headers || {}), Authorization: `Bearer ${token}` };
                return AXIOS_API_CREATE(OPT_REQUEST);
            }).catch(err => Promise.reject(err));
        }

        OPT_REQUEST._retry = true;
        isRefreshing = true;

        try {
            // El navegador inyectará la cookie automáticamente gracias a 'withCredentials: true'.
            const REFRESH_AXIOS_CREATE = axios.create({
                baseURL: API_BASE_URL, withCredentials: true //  para enviar la cookie actual y recibir la nueva rotada
            });

            // objeto vacío '{}' en el body porque los datos van en la cookie
            const REFRESH_RESPONSE = await REFRESH_AXIOS_CREATE.post(
                REFRESH_TOKEN_URL, {}, { headers: { Authorization: undefined } }
            );

            const NEW_TOKEN = REFRESH_RESPONSE.data?.data?.accessToken;

            if (!NEW_TOKEN) {
                throw new Error("El servidor respondió 200 pero el accessToken vino vacío en el JSON");
            }

            STORAGE_SESSION_HELPER.SET_STORAGE(APP_STORAGE.TOKEN_USER_AUTH, NEW_TOKEN);

            processQueue(null, NEW_TOKEN);

            OPT_REQUEST.headers = {
                ...(OPT_REQUEST.headers || {}), Authorization: `Bearer ${NEW_TOKEN}`
            };

            return AXIOS_API_CREATE(OPT_REQUEST);

        } catch (refreshError) {
            processQueue(refreshError, null);

            /*
             * SESION PERSISTENTE DEL PORTFOLIO
             * -------------------------------
             * Nunca limpiamos TOKEN_USER_AUTH por un 401/403 automatico.
             * El unico lugar autorizado a borrar la sesion es el boton
             * manual "Cerrar sesion" del UserAuthenticatedProvider.
             */

            return Promise.reject(refreshError);
        } finally {
            isRefreshing = false;
        }
    }

    return Promise.reject(error);
}
);

export default AXIOS_API_CREATE;